import { render, staticRenderFns } from "./SiloPropertyItem.vue?vue&type=template&id=a3ecf508"
import script from "./SiloPropertyItem.vue?vue&type=script&lang=js"
export * from "./SiloPropertyItem.vue?vue&type=script&lang=js"
import style0 from "./SiloPropertyItem.vue?vue&type=style&index=0&id=a3ecf508&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports